/* ==========================================================================
   产品卡「产品图 ↔ 佩戴图」移动端切换（小点点 + 左右滑）—— 全站通用
   适用所有产品卡 .product-card-wrapper：集合/专题/搜索页(.grid-item)、
   首页滑块(.slider-slide) 等。仅手机端、且卡片有 ≥2 张图时启用。
   与首页 SALE TOP PICKS 的那套（sale-top-picks.js 内）共用同一 class 与
   data 守卫(data-mobile-image-switch)，经守卫自动去重、互不重复加点。
   含 MutationObserver：筛选/分页/加载更多动态新增的卡也会自动补上切换。
   ========================================================================== */
(function () {
  'use strict';

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function setup(cardWrapper) {
    if (!isMobile()) return;
    // 首页滑块卡(.slider-slide)交给前端那套(sale-top-picks.js)处理，这里跳过 —— 消除重复扫描/双套样式
    if (cardWrapper.closest('.slider-slide')) return;
    if (cardWrapper.dataset.mobileImageSwitch === 'true') return; // 与首页那套共用守卫，去重

    var media = cardWrapper.querySelector('.card-media');
    var cardInner = cardWrapper.querySelector('.card-inner');
    if (!media || !cardInner) return;

    var images = media.querySelectorAll(
      'img.product-card-featured-image, img.product-card-secondary-image'
    );
    if (images.length < 2) return; // 没有佩戴图(第二张)就不启用，单图卡保持原样

    cardWrapper.dataset.mobileImageSwitch = 'true';
    cardWrapper.querySelectorAll('.mobile-card-image-dots').forEach(function (o) { o.remove(); });

    var currentIndex = 0, startX = 0, startY = 0, moveX = 0;
    var isHorizontalSwipe = false, isSwiping = false;

    var dots = document.createElement('div');
    dots.className = 'mobile-card-image-dots';

    function switchImage(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      currentIndex = index;
      images.forEach(function (img, i) { img.classList.toggle('is-mobile-active', i === currentIndex); });
      dots.querySelectorAll('.mobile-card-image-dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    images.forEach(function (img, index) {
      img.classList.toggle('is-mobile-active', index === 0);
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mobile-card-image-dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', '切换商品图片 ' + (index + 1));
      dot.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); switchImage(index);
      });
      dots.appendChild(dot);
    });

    // 圆点 append 进 .card-inner（图片框，CSS 里 position:relative）→ 由 CSS 绝对定位覆盖在图底，
    // 脱离文档流，JS 事后插入不再把标题/价格往下挤 → 零布局位移(零 CLS)。
    cardInner.appendChild(dots);

    // 绑到 card-inner（图片上方可能有 a 链接遮罩），capture 拦截避免外层 slider 跟滑
    cardInner.addEventListener('touchstart', function (e) {
      if (!isMobile()) return;
      var t = e.touches[0];
      startX = t.clientX; startY = t.clientY; moveX = 0;
      isHorizontalSwipe = false; isSwiping = false;
    }, { passive: true, capture: true });

    cardInner.addEventListener('touchmove', function (e) {
      if (!isMobile()) return;
      var t = e.touches[0], dx = t.clientX - startX, dy = t.clientY - startY;
      moveX = dx;
      if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
        isHorizontalSwipe = true; isSwiping = true;
        e.preventDefault(); e.stopPropagation();
      }
    }, { passive: false, capture: true });

    cardInner.addEventListener('touchend', function (e) {
      if (!isMobile()) return;
      if (!isHorizontalSwipe) return;
      if (Math.abs(moveX) < 35) return;
      e.preventDefault(); e.stopPropagation();
      if (moveX < 0) switchImage(currentIndex + 1); else switchImage(currentIndex - 1);
      setTimeout(function () { isSwiping = false; isHorizontalSwipe = false; moveX = 0; }, 150);
    }, { passive: false, capture: true });

    // 滑动后防误触进入详情
    cardInner.addEventListener('click', function (e) {
      if (!isMobile()) return;
      if (isSwiping || Math.abs(moveX) >= 35) { e.preventDefault(); e.stopPropagation(); }
    }, { capture: true });
  }

  function scan(root) {
    (root && root.querySelectorAll ? root : document)
      .querySelectorAll('.product-card-wrapper')
      .forEach(setup);
  }

  function boot() { scan(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // 动态新增的卡（筛选/分页/加载更多）：MutationObserver 兜底。
  // ① 只在「确有新增的 .product-card-wrapper」时才处理 —— 过滤购物车/预测搜索/懒加载等
  //    无关 DOM 变更，避免无谓的全文档扫描；
  // ② 扫描前 disconnect、扫描后重连 —— 自身插入圆点不会再触发观察者，结构上杜绝死循环、
  //    也省掉一次多余的全量扫描（不再依赖 data 守卫「侥幸」收敛）。
  var moScheduled = false;
  var mo = null;
  function mutationsHaveCard(records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('.product-card-wrapper')) ||
            (n.querySelector && n.querySelector('.product-card-wrapper'))) {
          return true;
        }
      }
    }
    return false;
  }
  // 观察范围收窄到主内容区（产品卡只出现在这里），避免购物车/搜索抽屉等 body 直下高频变更触发回调
  var moRoot = document.getElementById('MainContent') || document.querySelector('main') || document.body;
  function observeRoot() { mo.observe(moRoot, { childList: true, subtree: true }); }
  if (window.MutationObserver && moRoot) {
    mo = new MutationObserver(function (records) {
      if (moScheduled) return;
      if (!mutationsHaveCard(records)) return;
      moScheduled = true;
      requestAnimationFrame(function () {
        moScheduled = false;
        mo.disconnect();
        scan(moRoot);
        observeRoot();
      });
    });
    observeRoot();
  }

  // 主题编辑器 section 重载
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  // 桌面 → 手机 切换时补挂
  if (window.matchMedia) {
    var mq = window.matchMedia('(max-width: 749px)');
    var onChange = function () { if (isMobile()) scan(document); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }
})();
